module["exports"] = [
  "Marta",
  "Andrea",
  "Ana",
  "Anni",
  "Laura",
  "Maica",
  "Laura",
  "Lorena",
  "Matilde",
  "Jennifer",
  "Roser",
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es/name/female_first_name.js
// module id = 2818
// module chunks = 1610